var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-9-prep-adherence',{attrs:{"section":9,"page":21}},[_c('p',[_vm._v("\n        Thanks, moving right along!\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }